import React from "react";
import { RouterProvider } from "react-router-dom";
import router from "./components/router";
import "./App.scss";
import { AppCtxProvider } from "./components/ctx";
function App() {

  // eslint-disable-next-line no-restricted-globals
  history.pushState(null, "", location.href);
  window.onpopstate = function(event) {
    // eslint-disable-next-line no-restricted-globals
    history.go(1);
  };
  
  return (
    <div className="App">
      <AppCtxProvider>
        <RouterProvider router={router} />
      </AppCtxProvider>
    </div>
  );
}

export default App;
